import { Button, MenuItem, MenuSplitGroup, useIsOverflowItemVisible } from "@fluentui/react-components";
import CloseIcon from "~icons/material-symbols/close";
import { memo, MouseEventHandler } from "react";

type OverflowMenuItemProps = {
  tab: Record<string, any>;
  onClose: MouseEventHandler;
  onClick: MouseEventHandler;
};

export const OverflowMenuItem = memo(({ tab, onClick, onClose }: OverflowMenuItemProps) => {
  const isVisible = useIsOverflowItemVisible(tab.id);

  if (isVisible) {
    return null;
  }

  return (
    <MenuSplitGroup key={tab.id} as="div">
      <Button appearance="subtle" icon={<CloseIcon className="text-[16px]" />} onClick={onClose} />
      <MenuItem onClick={onClick} icon={null}>
        <span>{tab.name}</span>
      </MenuItem>
    </MenuSplitGroup>
  );
});
